import { render, staticRenderFns } from "./WeeklyConsultsChart.vue?vue&type=template&id=ca338ccc"
import script from "./WeeklyConsultsChart.vue?vue&type=script&lang=js"
export * from "./WeeklyConsultsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports